/* src/app/components/LoadingIndicator/styles.js */

export default () => ({
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff7f',
  },
});



// WEBPACK FOOTER //
// ./src/app/components/LoadingIndicator/styles.js